import React from 'react';

// The three-oval mark: red/amber/green, the brand's traffic-light signature.
// Decorative — every usage sits beside the "Ovalview" wordmark or inside a
// link that already carries its own accessible name.
const LogoMark = ({onDark, width = 40, height = 22}) => (
    <svg width={width} height={height} viewBox="0 0 40 22" aria-hidden="true">
        {onDark ? (
            <>
                <ellipse cx="11" cy="11" rx="9" ry="7" fill="none" stroke="#E5484D" strokeWidth="2"/>
                <ellipse cx="20" cy="11" rx="9" ry="7" fill="none" stroke="#F5A524" strokeWidth="2"/>
                <ellipse cx="29" cy="11" rx="9" ry="7" fill="none" stroke="#30A46C" strokeWidth="2"/>
            </>
        ) : (
            <>
                <ellipse cx="11" cy="11" rx="9" ry="7" fill="#FDECEC" stroke="#E5484D" strokeWidth="2"/>
                <ellipse cx="20" cy="11" rx="9" ry="7" fill="#FEF4DE" stroke="#F5A524" strokeWidth="2" fillOpacity="0.85"/>
                <ellipse cx="29" cy="11" rx="9" ry="7" fill="#E4F5EB" stroke="#30A46C" strokeWidth="2" fillOpacity="0.85"/>
            </>
        )}
    </svg>
);

export default LogoMark;
